import { InputType } from '../../../../../typings/client/input';

interface DynamicField<T = string> {
  name: T;
  label?: string;
  type: 'select' | 'text' | 'textArea' | 'radio';
  options?: Array<InputType.SelectOption>;
  placeholder?: string;
  required?: boolean;
}

export const getDiscomfortDynamicFields = (subcategories: Array<InputType.SelectOption>, subcategory: string): DynamicField[] => [
  {
    name: 'callStatus',
    label: 'Call Status',
    type: 'select',
    required: true,
    options: [
      { display: 'Connected', value: 'Connected' },
      { display: 'RNR', value: 'RNR' }
    ]
  },
  {
    name: 'productUsage',
    label: 'Product Usage',
    type: 'select',
    required: true,
    options: [
      { display: 'Excessive Application', value: 'Excessive Application' },
      { display: 'Applied as suggested', value: 'Applied as suggested' },
    ],
  },
  {
    name: 'exposure',
    label: 'Exposure',
    type: 'select',
    required: true,
    options: [
      { display: 'None', value: 'None' },
      { display: 'Sun', value: 'Sun' },
      { display: 'Pollution', value: 'Pollution' },
      { display: 'Beauty Procedures', value: 'Beauty Procedures' },
    ],
  },
  {
    name: 'actionTakenByOperator',
    label: 'Action Taken By Operator',
    type: 'select',
    required: true,
    options: [
      { display: 'Assigned to Doctor', value: 'Assigned to Doctor' },
      { display: 'Guided on Call', value: 'Guided on Call' },
      { display: 'Guided on VN', value: 'Guided on VN' },
      { display: 'Asked for photos', value: 'Asked for photos' },
    ],
  },
  {
    name: 'actionToBeTakenByDoctor',
    label: 'Action to be taken by Doctor',
    type: 'select',
    required: true,
    options: [
      { display: 'Call needed', value: 'Call needed' },
      { display: 'VN needed', value: 'VN needed' },
    ],
  },
  {
    name: 'previousSimilarComplaints',
    label: 'Previous Similar Complaints',
    type: 'radio',
    required: true,
  },
  {
    name: 'otherProducts',
    label: 'Other Products Used',
    type: 'radio',
    required: true,
  },
];

export const getTreatmentDynamicFields = (subcategories: Array<InputType.SelectOption>, subcategory: string): DynamicField[] => [
  {
    name: 'callStatus',
    label: 'Call Status',
    type: 'select',
    required: true,
    options: [
      { display: 'Connected', value: 'Connected' },
      { display: 'RNR', value: 'RNR' }
    ]
  },
  {
    name: 'actionTakenByOperator',
    label: 'Action Taken By Operator',
    type: 'select',
    required: true,
    options: [
      { display: 'Assigned to Doctor', value: 'Assigned to Doctor' },
      { display: 'Guided on Call', value: 'Guided on Call' },
      { display: 'Guided on VN', value: 'Guided on VN' },
      { display: 'Asked for photos', value: 'Asked for photos' },
    ],
  },
  {
    name: 'actionToBeTakenByDoctor',
    label: 'Action to be taken by Doctor',
    type: 'select',
    required: true,
    options: [
      { display: 'Call needed', value: 'Call needed' },
      { display: 'VN needed', value: 'VN needed' },
    ],
  },
  {
    name: 'checkupTaken',
    label: 'Checkup Taken',
    type: 'radio',
    required: true,
  },
  {
    name: 'usingProductsRegularly',
    label: 'Using Products Regulary',
    type: 'radio',
    required: true,
  },
  {
    name: 'lastReportRead',
    label: 'Last Report Read',
    type: 'radio',
    required: true,
  },
];

const ORDER_SUBCATEGORY_EXTRA_FIELDS: Record<string, DynamicField[]> = {
  'track order': [
    {
      name: 'trackingId',
      label: 'Tracking ID',
      type: 'text',
      required: false,
      placeholder: 'Enter tracking ID if available',
    },
    {
      name: 'ticketConcernDetail',
      label: 'Concern in detail',
      type: 'textArea',
      required: true,
      placeholder: 'write about the concern in details',
    },
  ],
  'delivery issues': [
    {
      name: 'deliveryAttempted',
      label: 'Delivery Attempted',
      type: 'radio',
      required: true,
    },
    {
      name: 'deliveryAgentCall',
      label: 'Delivery Agent Call',
      type: 'radio',
      required: true,
    },
    {
      name: 'userAvailability',
      label: 'User available at addess for next 24 to 48 hours?',
      type: 'radio',
      required: true,
    },
    {
      name: 'addressConfirmation',
      label: 'Address Confirmed by User',
      type: 'select',
      required: true,
      options: [
        { display: 'Yes', value: 'yes' },
        { display: 'No', value: 'no' },
        { display: 'Change in Pincode', value: 'change in pincode' },
        { display: 'Updated address in order notes', value: 'updated address in order notes' },
      ]
    },
    {
      name: 'ticketConcernDetail',
      label: 'Concern in detail',
      type: 'textArea',
      required: true,
      placeholder: 'write about the concern in details',
    },
  ],
  'missing products': [
    {
      name: 'conditionOfRecievedPackage',
      label: 'Condition of Recieved Package',
      type: 'select',
      options: [
        { display: 'Intact', value: 'intact' },
        { display: 'Tempered', value: 'tempered' },
      ],
      required: true,
    },
    {
      name: 'productsRecievedInBox',
      label: 'Products Recieved In Cureskin Box',
      type: 'radio',
    },
    {
      name: 'invoiceRecieved',
      label: 'Invoice Recieved by user',
      type: 'radio'
    },
    {
      name: 'unboxingVideo',
      label: 'Unboxing Video',
      type: 'radio'
    },
    {
      name: 'ticketConcernDetail',
      label: 'Concern in detail',
      type: 'textArea',
      required: true,
      placeholder: 'write about the concern in details',
    },
  ],
  'damaged products': [
    {
      name: 'conditionOfRecievedPackage',
      label: 'Condition of Recieved Package',
      type: 'select',
      options: [
        { display: 'Intact', value: 'intact' },
        { display: 'Tempered', value: 'tempered' },
      ],
      required: true,
    },
    {
      name: 'productsRecievedInBox',
      label: 'Products Recieved In Cureskin Box',
      type: 'radio',
    },
    {
      name: 'invoiceRecieved',
      label: 'Invoice Recieved by user',
      type: 'radio'
    },
    {
      name: 'unboxingVideo',
      label: 'Unboxing Video',
      type: 'radio'
    },
    {
      name: 'ticketConcernDetail',
      label: 'Concern in detail',
      type: 'textArea',
      required: true,
      placeholder: 'write about the concern in details',
    },
  ],
  'reordering concerns': [
    {
      name: 'ticketConcernDetail',
      label: 'Concern in detail',
      type: 'textArea',
      required: true,
      placeholder: 'write about the concern in details',
    }
  ],
  'cancellation request': [
    {
      name: 'ticketConcernDetail',
      label: 'Concern in detail',
      type: 'textArea',
      required: true,
      placeholder: 'write about the concern in details',
    }
  ],
  'address update request': [
    {
      name: 'ticketConcernDetail',
      label: 'Concern in detail',
      type: 'textArea',
      required: true,
      placeholder: 'write about the concern in details',
    },
  ],
  'phone update request': [
    {
      name: 'ticketConcernDetail',
      label: 'Concern in detail',
      type: 'textArea',
      required: true,
      placeholder: 'write about the concern in details',
    },
  ]
};

export const getOrdersDynamicFields = (subcategories: Array<InputType.SelectOption>, subcategory: string  ): DynamicField[] => {
  const baseFields: DynamicField[] = [
    {
      name: 'callStatus',
      label: 'Call Status',
      type: 'select',
      required: true,
      options: [
        { display: 'Connected', value: 'Connected' },
        { display: 'RNR', value: 'RNR' }
      ]
    },
    {
      name: 'actionTakenByOperator',
      label: 'Action Taken By Operator',
      type: 'select',
      required: true,
      options: getActionTakenByOperatorOptions(subcategory),
    },
  ];

  // Add extra fields for the selected subcategory, if any
  const extraFields = ORDER_SUBCATEGORY_EXTRA_FIELDS[subcategory] || [];
  return [...baseFields, ...extraFields];
};

export const getInstructionDynamicFields = (subcategories: Array<InputType.SelectOption>, subcategory: string  ): DynamicField[] => [
  {
    name: 'callStatus',
    label: 'Call Status',
    type: 'select',
    required: true,
    options: [
      { display: 'Connected', value: 'Connected' },
      { display: 'RNR', value: 'RNR' }
    ]
  },
  {
    name: 'actionTakenByOperator',
    label: 'Action Taken By Operator',
    type: 'select',
    required: true,
    options: [
      { display: 'Assigned to Doctor', value: 'Assigned to Doctor' },
      { display: 'Guided on Call', value: 'Guided on Call' },
      { display: 'Guided on VN', value: 'Guided on VN' },
    ],
  },
  {
    name: 'ticketConcernDetail',
    label: 'Concern in detail',
    type: 'textArea',
    required: true,
    placeholder: 'write about the concern in details',
  },
];

export const OTHER_DYNAMIC_FIELDS: DynamicField[] = [
  {
    name: 'ticketConcernDetail',
    label: 'Concern in detail',
    type: 'textArea',
    required: true,
    placeholder: 'write about the concern in details',
  },
];

export const CATEGORY_TO_SUBCATEGORIES: Record<string, Array<InputType.SelectOption>> = {
  discomfort: [
    { display: 'itching', value: 'itching' },
    { display: 'burning', value: 'burning' },
    { display: 'redness', value: 'redness' },
    { display: 'dryness', value: 'dryness' },
    { display: 'dullness', value: 'dullness' },
    { display: 'purging', value: 'purging' },
    { display: 'change treatment', value: 'change treatment' },
  ],
  treatment: [
    { display: 'treatment timeline', value: 'treatment timeline' },
    { display: 'checkup related', value: 'checkup related' },
    { display: 'makeup queries', value: 'makeup queries' },
    { display: 'hair color', value: 'hair color' },
    { display: 'dissatisfaction related', value: 'dissatisfaction related' },
    { display: 'diet', value: 'diet' },
    { display: 'requests products', value: 'requests products' },
    { display: 'facial hair', value: 'facial hair' },
    { display: 'facial salon', value: 'facial salon' },
    { display: 'home remedies', value: 'home remedies' },
    { display: 'facing hairfall', value: 'facing hairfall' },
    { display: 'treatment kit duration', value: 'treatment kit duration' },
  ],
  order: [
    { display: 'track order', value: 'track order' },
    { display: 'delivery issues', value: 'delivery issues' },
    { display: 'missing products', value: 'missing products' },
    { display: 'damaged products', value: 'damaged products' },
    { display: 'reordering concerns', value: 'reordering concerns' },
    { display: 'cancellation request', value: 'cancellation request' },
    { display: 'address update request', value: 'address update request' },
    { display: 'phone update request', value: 'phone update request' },
  ],
  instruction: [
    { display: 'regimen instruction', value: 'regimen instruction' },
    { display: 'product instruction', value: 'product instruction' },
    { display: 'other instruction', value: 'other instruction' },
  ],
  faq: [
    { display: 'default', value: 'default' },
  ],
  hair: [
    { display: 'in_scope', value: 'in_scope' },
    { display: 'off_topic', value: 'off_topic' },
    { display: 're_explain', value: 're_explain' },
    { display: 'regimen_missing', value: 'regimen_missing' },
    { display: 'default', value: 'default' },
  ],
  default: [],
  _default: [
    { display: 'burning', value: 'burning' },
    { display: 'itching', value: 'itching' },
    { display: 'redness', value: 'redness' },
    { display: 'dryness', value: 'dryness' },
    { display: 'change my treatment', value: 'change my treatment' },
  ]
};

export const ACTION_TAKEN_BY_OPERATOR_OPTIONS: Record<string, Array<InputType.SelectOption>> = {
  'track order': [
    { display: 'Guided User on call', value: 'Guided User on call' },
    { display: 'Guided User on VN', value: 'Guided User on VN' },
    { display: 'Added relevant escalation notes', value: 'Added relevant escalation notes' },
  ],
  'delivery issues': [
    { display: 'Guided User on call', value: 'Guided User on call' },
    { display: 'Guided User on VN', value: 'Guided User on VN' },
    { display: 'Added relevant escalation notes', value: 'Added relevant escalation notes' },
  ],
  'missing products': [
    { display: 'Asked user for images and videos', value: 'Asked user for images and videos' },
  ],
  'damaged products': [
    { display: 'Asked user for images and videos', value: 'Asked user for images and videos' },
  ],
  'reordering concerns': [
    { display: 'Assigned to Sales Team', value: 'Assigned to Sales Team' },
    { display: 'Assigned to Initial Team', value: 'Assigned to Initial Team' },
    { display: 'COD option requested', value: 'COD option requested' },
    { display: 'New order placed', value: 'New order placed' },
  ],
  'cancellation request': [
    { display: 'Guided User on call', value: 'Guided User on call' },
    { display: 'Guided User on VN', value: 'Guided User on VN' },
    { display: 'User ready to accept order', value: 'User ready to accept order' },
  ],
  'address update request': [
    { display: 'address updated in order notes', value: 'address updated in order notes' },
    { display: 'address updated in clickpost', value: 'address updated in clickpost' },
  ],
  'phone update request': [
    { display: 'number updated in order notes', value: 'number updated in order notes' },
    { display: 'number updated on clickpost', value: 'number updated on clickpost' },
  ],
};

export function getSubcategoriesForCategory(category: string): Array<InputType.SelectOption> {
  return CATEGORY_TO_SUBCATEGORIES[category?.toLowerCase?.()] ?? CATEGORY_TO_SUBCATEGORIES._default;
}

export function getActionTakenByOperatorOptions(subcategory: string): Array<InputType.SelectOption> {
  return ACTION_TAKEN_BY_OPERATOR_OPTIONS[subcategory] ?? [];
}
